var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.4 0h13.2c3 0 5.4 2.4 5.4 5.4v13.1c0 3-2.4 5.5-5.4 5.5h-13.2c-3 0-5.4-2.5-5.4-5.5v-13.1c0-3 2.4-5.4 5.4-5.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m9.6 9.3h3v1.6h0.1c0.4-0.8 1.4-1.6 3-1.6 3.2 0 3.8 2 3.8 4.6v5.5h-3.2v-4.9c0-1.1 0-2.6-1.6-2.6-1.7 0-1.9 1.3-1.9 2.5v5h-3.2zm-3.4-1.4c-0.9 0-1.7-0.7-1.7-1.7 0-0.9 0.8-1.6 1.7-1.6 0.9 0 1.6 0.7 1.6 1.6 0 1-0.7 1.7-1.6 1.7zm-1.7 1.4h3.3v10.1h-3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.990a59077f2f62877095c9d9cdb824e5.svg";
export { ForwardRef as ReactComponent };